import { IAirTimeRegistrationRepository } from "api/merchantRepository/airTimeRegistration/AirTimeRegistrationRepository";
import { ICashFlowRepository } from "api/merchantRepository/cashFlow/CashFlowRepository";
import { IFilterFeatureRepository } from "api/merchantRepository/filterFeature/FilterFeatureRepository";
import { IMobiSimRegistrationRepository } from "api/merchantRepository/mobiSimRegistration/MobiSimRegistrationRepository";
import { INiceSimRegistrationRepository } from "api/merchantRepository/niceSimRegistration/NiceSimRegistrationRepository";
import { INotificationRepository } from "api/merchantRepository/notification/NotificationRepository";
import { IPackageRegistrationRepository } from "api/merchantRepository/packageRegistration/PackageRegistrationRepository";
import { ISupportFeatureRepository } from "api/merchantRepository/supportFeature/SupportFeatureRepository";
import { ITravelSimRegistrationRepository } from "api/merchantRepository/travelSimRegistration/TravelSimRegistrationRepository";
import { IAppTransactionRepository } from "api/repositories/appTransaction/AppTransactionRepository";
import { IAuthenticationsRepository } from "api/repositories/authentications/AuthenticationsRepository";
import { ICarrierRepository } from "api/repositories/carrier/CarrierRepository";
import { IGeneralRepository } from "api/repositories/general/GeneralRepository";
import { IUserManagementRepository } from "api/repositories/userManagement/UserManagementRepository";
import { DependenciesInjection } from "di/DependencyInjection";
import { InjectionToken } from "utils/injectionToken/InjectionToken";

//Class khai báo repo thay cho method DependenciesInjection.getRepo để tránh khai báo dài dòng
export class ServiceRepo {
  static getAuthenRepo() {
    return DependenciesInjection.getRepo<IAuthenticationsRepository>(
      InjectionToken.IAuthenticationsRepository
    );
  }
  static getDashboardRepo() {
    return DependenciesInjection.getRepo<IGeneralRepository>(
      InjectionToken.IGeneralRepository
    );
  }
  static getUserManagementRepo() {
    return DependenciesInjection.getRepo<IUserManagementRepository>(
      InjectionToken.IUserManagementRepository
    );
  }
  static getAppTransactionRepo() {
    return DependenciesInjection.getRepo<IAppTransactionRepository>(
      InjectionToken.IAppTransactionRepository
    );
  }
  static getCarrierRepo() {
    return DependenciesInjection.getRepo<ICarrierRepository>(
      InjectionToken.ICarrierRepository
    );
  }
  static getAirTimeRegistrationRepo() {
    return DependenciesInjection.getRepo<IAirTimeRegistrationRepository>(
      InjectionToken.IAirTimeRegistrationRepository
    );
  }
  static getPackageRegistrationRepo() {
    return DependenciesInjection.getRepo<IPackageRegistrationRepository>(
      InjectionToken.IPackageRegistrationRepository
    );
  }
  static getNiceSimRegistrationRepo() {
    return DependenciesInjection.getRepo<INiceSimRegistrationRepository>(
      InjectionToken.INiceSimRegistrationRepository
    );
  }
  static getMobiSimRegistrationRepo() {
    return DependenciesInjection.getRepo<IMobiSimRegistrationRepository>(
      InjectionToken.IMobiSimRegistrationRepository
    );
  }
  static getTravelSimRegistrationRepo() {
    return DependenciesInjection.getRepo<ITravelSimRegistrationRepository>(
      InjectionToken.ITravelSimRegistrationRepository
    );
  }
  static getSupportFeatureRepo() {
    return DependenciesInjection.getRepo<ISupportFeatureRepository>(
      InjectionToken.ISupportFeatureRepository
    );
  }
  static getFilterFeatureRepo() {
    return DependenciesInjection.getRepo<IFilterFeatureRepository>(
      InjectionToken.IFilterFeatureRepository
    );
  }
  static getCashFlowRepo() {
    return DependenciesInjection.getRepo<ICashFlowRepository>(
      InjectionToken.ICashFlowRepository
    );
  }
  static getNotificationRepo() {
    return DependenciesInjection.getRepo<INotificationRepository>(
      InjectionToken.INotificationRepository
    );
  }
}
